module.exports = __webpack_public_path__ + "static/media/hoops_panjang(1).9a00a2f2.png";